import { render } from "./ControlsPosition.vue?vue&type=template&id=447eb48c"
import script from "./ControlsPosition.vue?vue&type=script&lang=ts"
export * from "./ControlsPosition.vue?vue&type=script&lang=ts"
script.render = render

export default script